import { useState, useCallback } from "react";

export const usePhotoValidation = (photos = []) => {
    const [images, setImages] = useState({});
    const [imageErrors, setImageErrors] = useState({});

    const validatePhotos = useCallback(() => {
        const nextErrors = {};
        const requiredPhotos = photos.filter((photo) => photo.required);

        requiredPhotos.forEach((photo) => {
            if (!images[photo.name]) {
                nextErrors[photo.name] = "This photo is required";
            }
        });

        setImageErrors(nextErrors);
        return Object.keys(nextErrors).length === 0;
    }, [photos, images]);

    const handleImagesChange = useCallback((newImages) => {
        setImages(newImages);
        setImageErrors((previousErrors) => {
            const updatedErrors = { ...previousErrors };
            Object.keys(newImages).forEach((key) => {
                delete updatedErrors[key];
            });
            return updatedErrors;
        });
    }, []);

    const resetPhotos = useCallback(() => {
        setImages({});
        setImageErrors({});
    }, []);

    return {
        images,
        imageErrors,
        validatePhotos,
        handleImagesChange,
        resetPhotos,
    };
};
